import Vue from 'vue'
import App from './App.vue'
import Toast from 'vue-toastification'
import VuePortal from '@linusborg/vue-simple-portal'
import './assets/tailwind.css'
import '@/assets/static/scss/noty.scss'
import '@/registerServiceWorker'
import {i18n} from '@/integrations/i18n'
import {router} from '@/integrations/router'
import edjsHTML from '@/integrations/edjsParser'
import {eventBus} from './utils/eventBus'
import directives from '@/utils/directives'
import screen from '@/config/screen'
import helpers from '@/utils/helpers'
import {store} from '@/integrations/store'
import {offlinePlugin} from '@/utils/offline'
import '@/utils/prototypes'
import '@/utils/polyfills/aLinkBehavior'
import '@/globals'
import '@/components'
import '@/integrations/icons'
import VueZoomer from 'vue-zoomer'
import VueBlurHash from 'vue-blurhash'
import 'vue-blurhash/dist/vue-blurhash.css'
import Editor from 'vue-editor-js/src/index'
import VueQrcodeReader from "vue-qrcode-reader";

/* SOCKETS */
import socket_chat from '@/pages/Chat/socket'
Vue.use(socket_chat)
/* SOCKETS */

Vue.config.productionTip = false

const helpersPlugin = {
  install() {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}
Vue.prototype.$edjsHTML = edjsHTML

const eventBusPlugin = {
  install() {
    Vue.eventBus = eventBus
    Vue.prototype.$eventBus = eventBus
  }
}

const screenPlugin = {
  install() {
    Vue.screen = screen
    Vue.prototype.$screen = screen
  }
}

Vue.use(VueZoomer)
Vue.use(helpersPlugin)
Vue.use(eventBusPlugin)
Vue.use(Editor)
Vue.use(screenPlugin)
Vue.use(VuePortal)
Vue.use(VueBlurHash)
Vue.use(VueQrcodeReader)
Vue.use(Toast, {
  position: 'bottom-center',
  transition: 'Vue-Toastification__fade',
  timeout: 1500,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: false,
  rtl: false
})
Vue.use(offlinePlugin)

new Vue({
  render: h => h(App),
  router,
  i18n,
  store,
  directives: {
    ...directives
  }
}).$mount('#app')
